import e from "./Pagination.vue_rollup-plugin-vue=script.js";
export default (function (e, t, a, s, n, i, r, u) {
  var l = ("function" == typeof a ? a.options : a) || {};
  return l.__file = "Pagination.vue", l.render || (l.render = e.render, l.staticRenderFns = e.staticRenderFns, l._compiled = !0, n && (l.functional = !0)), l._scopeId = s, l;
})({
  render: function render() {
    var e,
        t = this,
        a = t.$createElement,
        s = t._self._c || a;
    return t.state ? s("div", {
      class: (e = {}, e[t.suit()] = !0, e[t.suit("", "noRefinement")] = t.state.nbPages <= 1, e)
    }, [t._t("default", function () {
      var e, a, n, i;
      return [s("ul", {
        class: t.suit("list")
      }, [t.showFirst ? s("li", {
        class: (e = {}, e[t.suit("item")] = !0, e[t.suit("item", "disabled")] = t.state.isFirstPage, e[t.suit("item", "firstPage")] = !0, e)
      }, [t._t("first", function () {
        return [t.state.isFirstPage ? [s("span", {
          class: t.suit("link"),
          attrs: {
            "aria-label": "First Page"
          }
        }, [t._v("‹‹")])] : [s("a", {
          class: t.suit("link"),
          attrs: {
            "aria-label": "First Page",
            href: t.state.createURL(0)
          },
          on: {
            click: function click(e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "left", 37, e.key, ["Left", "ArrowLeft"]) ? null : e.ctrlKey || e.shiftKey || e.altKey || e.metaKey ? null : "button" in e && 0 !== e.button ? null : (e.preventDefault(), t.refine(0));
            }
          }
        }, [t._v("‹‹")])]];
      }, {
        createURL: function createURL() {
          return t.state.createURL(0);
        },
        isFirstPage: t.state.isFirstPage,
        refine: function refine() {
          return t.refine(0);
        }
      })], 2) : t._e(), t._v(" "), t.showPrevious ? s("li", {
        class: (a = {}, a[t.suit("item")] = !0, a[t.suit("item", "disabled")] = t.state.isFirstPage, a[t.suit("item", "previousPage")] = !0, a)
      }, [t._t("previous", function () {
        return [t.state.isFirstPage ? [s("span", {
          class: t.suit("link"),
          attrs: {
            "aria-label": "Previous Page"
          }
        }, [t._v("‹")])] : [s("a", {
          class: t.suit("link"),
          attrs: {
            "aria-label": "Previous Page",
            href: t.state.createURL(t.state.currentRefinement - 1)
          },
          on: {
            click: function click(e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "left", 37, e.key, ["Left", "ArrowLeft"]) ? null : e.ctrlKey || e.shiftKey || e.altKey || e.metaKey ? null : "button" in e && 0 !== e.button ? null : (e.preventDefault(), t.refine(t.state.currentRefinement - 1));
            }
          }
        }, [t._v("‹")])]];
      }, {
        createURL: function createURL() {
          return t.state.createURL(t.state.currentRefinement - 1);
        },
        isFirstPage: t.state.isFirstPage,
        refine: function refine() {
          return t.refine(t.state.currentRefinement - 1);
        }
      })], 2) : t._e(), t._v(" "), t._l(t.state.pages, function (e) {
        var a;
        return s("li", {
          key: e,
          class: (a = {}, a[t.suit("item")] = !0, a[t.suit("item", "page")] = !0, a[t.suit("item", "selected")] = t.state.currentRefinement === e, a)
        }, [t._t("item", function () {
          return [s("a", {
            class: t.suit("link"),
            attrs: {
              href: t.state.createURL(e),
              "aria-label": "Page " + (e + 1)
            },
            on: {
              click: function click(a) {
                return !a.type.indexOf("key") && t._k(a.keyCode, "left", 37, a.key, ["Left", "ArrowLeft"]) ? null : a.ctrlKey || a.shiftKey || a.altKey || a.metaKey ? null : "button" in a && 0 !== a.button ? null : (a.preventDefault(), t.refine(e));
              }
            }
          }, [t._v(t._s(e + 1))])];
        }, {
          page: e,
          createURL: function createURL() {
            return t.state.createURL(e);
          },
          isFirstPage: t.state.isFirstPage,
          isLastPage: t.state.isLastPage,
          refine: function refine() {
            return t.refine(e);
          }
        })], 2);
      }), t._v(" "), t.showNext ? s("li", {
        class: (n = {}, n[t.suit("item")] = !0, n[t.suit("item", "disabled")] = t.state.isLastPage, n[t.suit("item", "nextPage")] = !0, n)
      }, [t._t("next", function () {
        return [t.state.isLastPage ? [s("span", {
          class: t.suit("link"),
          attrs: {
            "aria-label": "Next Page"
          }
        }, [t._v("›")])] : [s("a", {
          class: t.suit("link"),
          attrs: {
            "aria-label": "Next Page",
            href: t.state.createURL(t.state.currentRefinement + 1)
          },
          on: {
            click: function click(e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "left", 37, e.key, ["Left", "ArrowLeft"]) ? null : e.ctrlKey || e.shiftKey || e.altKey || e.metaKey ? null : "button" in e && 0 !== e.button ? null : (e.preventDefault(), t.refine(t.state.currentRefinement + 1));
            }
          }
        }, [t._v("›")])]];
      }, {
        createURL: function createURL() {
          return t.state.createURL(t.state.currentRefinement + 1);
        },
        isLastPage: t.state.isLastPage,
        refine: function refine() {
          return t.refine(t.state.currentRefinement + 1);
        }
      })], 2) : t._e(), t._v(" "), t.showLast ? s("li", {
        class: (i = {}, i[t.suit("item")] = !0, i[t.suit("item", "disabled")] = t.state.isLastPage, i[t.suit("item", "lastPage")] = !0, i)
      }, [t._t("last", function () {
        return [t.state.isLastPage ? [s("span", {
          class: t.suit("link"),
          attrs: {
            "aria-label": "Last Page, Page " + t.state.nbPages
          }
        }, [t._v("\n              ››\n            ")])] : [s("a", {
          class: t.suit("link"),
          attrs: {
            "aria-label": "Last Page, Page " + t.state.nbPages,
            href: t.state.createURL(t.state.nbPages - 1)
          },
          on: {
            click: function click(e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "left", 37, e.key, ["Left", "ArrowLeft"]) ? null : e.ctrlKey || e.shiftKey || e.altKey || e.metaKey ? null : "button" in e && 0 !== e.button ? null : (e.preventDefault(), t.refine(t.state.nbPages - 1));
            }
          }
        }, [t._v("››")])]];
      }, {
        createURL: function createURL() {
          return t.state.createURL(t.state.nbPages - 1);
        },
        isLastPage: t.state.isLastPage,
        refine: function refine() {
          return t.refine(t.state.nbPages - 1);
        }
      })], 2) : t._e()], 2)];
    }, {
      refine: t.refine,
      createURL: t.state.createURL,
      currentRefinement: t.state.currentRefinement,
      nbHits: t.state.nbHits,
      nbPages: t.state.nbPages,
      pages: t.state.pages,
      isFirstPage: t.state.isFirstPage,
      isLastPage: t.state.isLastPage
    })], 2) : t._e();
  },
  staticRenderFns: []
}, 0, e, void 0, !1);